import axios from 'axios'
import { attachCsrfInterceptor } from '@/common/api/csrf'
import { BFF_BASE_URL } from '@/common/api/bffBaseUrl'

export const bffAuthClient = axios.create({
    baseURL: BFF_BASE_URL,
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
})

attachCsrfInterceptor(bffAuthClient)
